import ConfirmIconButton from "../../components/button/ConfirmIconButton";
import {Alert} from "react-bootstrap";
import ConfirmButton from "../../components/button/ConfirmButton";
import IconButton from "../../components/button/IconButton";
import React, {useState} from "react";
import * as PropTypes from "prop-types";
import LineSimulations from "../simulation/LineSimulations";
import ConfirmWithCommentAndDateButton from "../../components/button/ConfirmWithCommentAndDateButton";
import {Actions} from "../../../client/Actions";
import { useModels } from "../../helpers/models";
import Table from "../../components/table/Table";
import columns from "./CleaningModalTableConfig";
import ModalForm from "../../components/form/ModalForm";
import * as ProductionStartFormConfig from "./ProductionStartFormConfig";
import * as ProductionEndFormConfig from "./ProductionEndFormConfig";
import {hasProductionFullAccess} from "../../helpers/jwt";
import { useTranslation } from 'react-i18next';

InstallationBar.propTypes = {
    onClearInstalls: PropTypes.func,
    currentTotalPartsCount: PropTypes.func,
    installations: PropTypes.any,
    totalPartsCount: PropTypes.func,
    notSavedInstallsCount: PropTypes.number,
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
    loadData: PropTypes.func,
    simulation: PropTypes.bool,
    line: PropTypes.any,
    productionHistory: PropTypes.any,
    historicalProduction: PropTypes.bool
};

export function InstallationBar(props) {

    const { t } = useTranslation();
    const models = useModels();

    const [cleaningDate, setCleaningDate] = useState();
    const [openCreateProduction, setOpenCreateProduction] = useState(false);
    const [openEndProduction, setOpenEndProduction] = useState(false);

    function startProduction(data) {
        data.lineId = props.line.id

        Actions.post("production/create", data, props.loadData)
    }


    function endProduction(data) {
        data.lineId = props.line.id

        Actions.post("production/deactivate/" + props.line.id, data, props.loadData, t("production.finished"))
    }

    return <div className={"d-flex"}>

        {!props.simulation && !props.historicalProduction &&
            <LineSimulations line={props.line} setLoader={props.setLoader}/>
        }
        {
            hasProductionFullAccess() &&
            props.installations && props.installations.length > 0 && props.notSavedInstallsCount === 0 && !props.simulation && !props.historicalProduction &&
            <ConfirmWithCommentAndDateButton
                className={"mr-2"}
                variant={"outline-primary"}
                modalSize={"lg"}
                commentRequired={false}
                commentEnabled={false}
                date={cleaningDate}
                setDate={setCleaningDate}
                onConfirm={() => {
                    props.setLoader(true); // Start loading

                    const installationsByFormat = props.installations
                        .filter(install => install.part) // Only include installations with parts
                        .reduce((grouped, install) => {
                            const formatId = install.part.formatId;
                            if (!grouped[formatId]) {
                                grouped[formatId] = [];
                            }
                            grouped[formatId].push(install.part.id);
                            return grouped;
                        }, {});

                    const formatIds = Object.keys(installationsByFormat);
                    let completedRequests = 0;

                    formatIds.forEach((formatId, index) => {
                        Actions.post(`management/${models.cleaning.url}/${formatId}`, {
                            cleaningDate: cleaningDate,
                            parts: installationsByFormat[formatId], // Pass parts as an array of IDs
                        }, () => {
                            completedRequests++;

                            // If all requests are finished, stop loading
                            if (completedRequests === formatIds.length) {
                                props.loadData()// Finish loading after all POST requests complete
                            }
                        });
                    });

                    // In case there are no formatIds
                    if (formatIds.length === 0) {
                        props.setLoader(false);
                    }
                }}
                buttonsConf={{
                    save: t("production.clean"),
                    cancel: t("common.cancel")
                }}
                confirmTitle={<><i
                    className={"mr-2 fa " + models.cleaning.icon}></i>{models.cleaning.title}</>}
                modelChildren={
                    <div className={"mt-5"}>
                        <Table
                            columns={columns(t)}
                            setLoader={props.setLoader}
                            initData={props.installations
                                .filter(install => install.part)
                                .map(install => {
                                    return {
                                        partId: install.part.id,
                                        partName: install.part.formatPart.name,
                                        partStatus: install.part.partStatus,
                                        files: install.part.files,
                                        formatName: install.part.formatId
                                    }
                                })}
                        />


                    </div>
                }
                icon={models.cleaning.icon}
                tooltip={models.cleaning.title}
            />
        }

        {!props.activeProduction && !props.historicalProduction && hasProductionFullAccess() &&
            <>
                <ConfirmIconButton
                    variant={"outline-primary"}
                    modalSize={"lg"}
                    className={"mr-2"}
                    icon={"fa-eraser"}  
                    tooltip={t("production.remove_all_from_line")}
                    confirmTitle={t("production.removing_all_from_line")}
                    onConfirm={props.onClearInstalls}
                    confirmDescription={t("production.confirm_remove_all_from_line")}   
                />
            </>}
        {props.currentTotalPartsCount !== undefined && <Alert variant={"primary"}
                                                              className={"mb-0 mr-2"}>{`${t("production.installed")} (${props.currentTotalPartsCount + "/" + props.totalPartsCount})`}</Alert>}
        {!props.activeProduction && !props.historicalProduction && hasProductionFullAccess() &&
            <>

                {props.notSavedInstallsCount > 0 &&
                    <Alert variant={"warning"}
                           className={"mb-0 mr-2"}>{`${t("production.not_saved")} (${props.notSavedInstallsCount})`}</Alert>}
                {props.notSavedInstallsCount > 0 &&

                    <ConfirmButton
                        variant={"outline-secondary"}
                        modalSize={"lg"}
                        className={"mr-2"}
                        confirmTitle={t("production.cancellation")}
                        confirmDescription={t("production.confirm_revert_line_state")}
                        onConfirm={props.onCancel}
                    >
                        {t("common.cancel")}
                    </ConfirmButton>
                }

                {props.notSavedInstallsCount > 0 &&
                    <ConfirmButton
                        variant={"outline-primary"}
                        modalSize={"lg"}
                        className={"mr-2"}
                        confirmTitle={t("production.save_line_installation_state")}
                        confirmDescription={t("production.confirm_save_line_state")}
                        onConfirm={props.onSave}
                    >
                        {t("forms.save")}
                    </ConfirmButton>
                }
                {props.notSavedInstallsCount === 0 && props.allInstalled && !props.simulation &&
                    <IconButton
                        variant={"primary"}
                        className={"mr-2"}
                        icon={"fa-play"}
                        tooltip={t("production.start_production")}
                        onClick={() => setOpenCreateProduction(true)}
                    />
                }
                {props.notSavedInstallsCount === 0 && !props.allInstalled && props.currentTotalPartsCount > 0 && !props.simulation &&
                    <IconButton
                        variant={"warning"}
                        className={"mr-2"}
                        icon={"fa-play"}
                        tooltip={t("production.start_conditional_production")}
                        onClick={() => setOpenCreateProduction(true)}
                    />
                }

            </>
        }
        {props.activeProduction && hasProductionFullAccess() &&
            <>
                {(props.activeProduction ? !props.activeProduction.condition : props.allInstalled) ?
                    <Alert variant={"primary"} className={"mb-0 mr-2"}>{t("production.in_progress")}</Alert>
                    :
                    <Alert variant={"warning"} className={"mb-0 mr-2"}>{t("production.in_conditional_progress")}</Alert>
                }
                <IconButton
                    variant={"primary"}
                    className={"mr-2"}
                    icon={"fa-stop"}
                    tooltip={t("production.end_production")}
                    onClick={() => setOpenEndProduction(true)}
                />
            </>
        }

        {props.historicalProduction &&
            <>
                {!props.historicalProduction.condition ?
                    <Alert variant={"primary"} className={"mb-0 mr-2"}>{t("menu.production")}</Alert>
                    :
                    <Alert variant={"warning"} className={"mb-0 mr-2"}>{t("production.conditional_production")}</Alert>
                }
            </>
        }


        <ModalForm
            open={openCreateProduction}
            setLoader={props.setLoader}
            setOpen={setOpenCreateProduction}
            fields={ProductionStartFormConfig.fields(t)}
            title={props.allInstalled ? t("production.start_production") : t("production.start_conditional_production")}
            size={"md"}
            buttonsConf={{
                save: t("common.start"),
                cancel: t("common.cancel")
            }}
            customSave={(data) => {
                startProduction(data)
            }
            }
        />
        <ModalForm
            open={openEndProduction}
            setLoader={props.setLoader}
            setOpen={setOpenEndProduction}
            initialData={props.productionHistory && props.productionHistory[0] ? {quantity: props.productionHistory[0].quantity} : undefined}
            fields={ProductionEndFormConfig.fields(t)}
            title={t("production.end_production")}
            buttonsConf={{
                save: t("production.end"),
                cancel: t("common.cancel")
            }}
            size={"md"}
            customSave={(data) => {
                endProduction(data)
            }
            }
        />
    </div>;
}